/** 주소 앞 로케일 접두사(`/ja/...`)를 뗀다. 쿼리·해시는 남긴다. */
export function stripLocalePrefix(
  url: string,
  locales: readonly string[] = [],
): string {
  const locale = locales.find(
    candidate =>
      url === `/${candidate}` ||
      (url.startsWith(`/${candidate}`) &&
        ['/', '?', '#'].includes(url.charAt(candidate.length + 1))),
  );
  if (!locale) return url;
  const rest = url.slice(locale.length + 1);
  return rest.startsWith('/') ? rest : `/${rest}`;
}

/**
 * history 항목이 지금 라우터 주소의 것인가. 다른 주소로 뒤로·앞으로 가면 history 는 popstate 때 바로 바뀌고
 * 라우터는 화면을 받은 뒤 따라오므로, 그 사이엔 history key 를 지금 화면의 것으로 보지 않는다.
 */
export function isHistoryEntryShown(
  asPath: string,
  locales?: readonly string[],
): boolean {
  if (typeof window === 'undefined') return true;
  const historyState = window.history.state as { as?: unknown } | null;
  if (typeof historyState?.as !== 'string') return true;
  return stripLocalePrefix(historyState.as, locales) === asPath;
}
